import React from 'react';
import CommonTableDesktop from './commonTableDesktop/commonTableDesktop';
import CommonTableMobile from './commonTableMobile/commonTableMobile';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import styles from './commonTableModule.module.scss';

function CommonTableModule(props) {
  const { width } = useWindowDimensions();
  return (
    <div className={styles.container}>
      {width < 768 && <CommonTableMobile {...props} />}
      {width >= 768 && <CommonTableDesktop {...props} />}
    </div>
  );
}
export default CommonTableModule;
